/**
 * 관공서 공휴일·대체공휴일 (2026–2027).
 *
 * 출처 (확인 2026-10-16):
 * - 2027: 한국천문연구원 천문우주지식정보 달력자료 2027 (자료생성 2026-06-30, 우주항공청
 *   2027년도 월력요항 발표 2026-06-29 다음 날)
 *   https://astro.kasi.re.kr/kor/life/post/calendarData?year=2027
 *   공휴일 24일(일요일 겹침 포함) — YTN 2026-06-29 보도와 수가 같다.
 * - 2026: 같은 출처 2026 자료 + 노동절(5/1)·제헌절(7/17)의 관공서 공휴일 편입
 *   (2027 월력요항 보도: "노동절·제헌절이 2026년부터 공휴일로 적용")
 *   https://www.ytn.co.kr/_ln/0105_202606291128526819
 * 2028년 이후는 월력요항 발표 뒤에 더한다. 추측으로 채우지 않는다.
 */
export const KR_HOLIDAY_YEARS = [2026, 2027] as const;

export const KR_HOLIDAYS: Readonly<Record<string, string>> = {
	"2026-01-01": "신정",
	"2026-02-16": "설날 연휴",
	"2026-02-17": "설날",
	"2026-02-18": "설날 연휴",
	"2026-03-01": "3·1절",
	"2026-03-02": "대체공휴일",
	"2026-05-01": "노동절",
	"2026-05-05": "어린이날",
	"2026-05-24": "부처님오신날",
	"2026-05-25": "대체공휴일",
	"2026-06-03": "지방선거일",
	"2026-06-06": "현충일",
	"2026-07-17": "제헌절",
	"2026-08-15": "광복절",
	"2026-08-17": "대체공휴일",
	"2026-09-24": "추석 연휴",
	"2026-09-25": "추석",
	"2026-09-26": "추석 연휴",
	"2026-10-03": "개천절",
	"2026-10-05": "대체공휴일",
	"2026-10-09": "한글날",
	"2026-12-25": "성탄절",
	"2027-01-01": "신정",
	"2027-02-06": "설날 연휴",
	"2027-02-07": "설날",
	"2027-02-08": "설날 연휴",
	"2027-02-09": "대체공휴일",
	"2027-03-01": "3·1절",
	"2027-05-01": "노동절",
	"2027-05-03": "대체공휴일",
	"2027-05-05": "어린이날",
	"2027-05-13": "부처님오신날",
	"2027-06-06": "현충일",
	"2027-07-17": "제헌절",
	"2027-07-19": "대체공휴일",
	"2027-08-15": "광복절",
	"2027-08-16": "대체공휴일",
	"2027-09-14": "추석 연휴",
	"2027-09-15": "추석",
	"2027-09-16": "추석 연휴",
	"2027-10-03": "개천절",
	"2027-10-04": "대체공휴일",
	"2027-10-09": "한글날",
	"2027-10-11": "대체공휴일",
	"2027-12-25": "성탄절",
	"2027-12-27": "대체공휴일",
};

export function holidayName(dateKey: string): string | null {
	return KR_HOLIDAYS[dateKey] ?? null;
}

export function hasHolidayData(year: number): boolean {
	return (KR_HOLIDAY_YEARS as readonly number[]).includes(year);
}
